import { EmailValidatorDirective } from './email.validator';
import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DefaultImageDirective } from './default-image.pipe';
import { OutsideClickDirective } from './outside-click/outside-click.directive';
import { SafeUrlPipe } from './safe-url.pipe';
import { NgArrayPipesModule, NgStringPipesModule } from 'ngx-pipes';
import { PriceFormatterPipe } from './pipes/price-formatter/price-formatter.pipe';
import { FeatureFlagDirective } from './directives/feature-flag/feature-flag.directive';
import { TranslateCutPipe } from './pipes/translate-cut.pipe';
import { NgFirstOrDefaultPipeModule } from './pipes/angular-pipes/first-or-default.pipe';
import { NgHeadPipeModule } from './pipes/angular-pipes/head.pipe';
import { NgJoinPipeModule } from './pipes/angular-pipes/join.pipe';
import { NouisliderModule } from 'ng2-nouislider';
import { NgReplacePipeModule } from './pipes/angular-pipes/replace.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgArrayPipesModule,
    NgStringPipesModule,
    NgFirstOrDefaultPipeModule,
    NgHeadPipeModule,
    NgJoinPipeModule,
    NgReplacePipeModule,
    NouisliderModule
  ],
  declarations: [
    EmailValidatorDirective,
    DefaultImageDirective,
    OutsideClickDirective,
    SafeUrlPipe,
    PriceFormatterPipe,
    FeatureFlagDirective,
    TranslateCutPipe
  ],
  exports: [
    EmailValidatorDirective,
    DefaultImageDirective,
    OutsideClickDirective,
    SafeUrlPipe,
    TranslateModule,
    CommonModule,
    FormsModule,
    NgArrayPipesModule,
    NgStringPipesModule,
    NgFirstOrDefaultPipeModule,
    NgHeadPipeModule,
    NgJoinPipeModule,
    NgReplacePipeModule,
    PriceFormatterPipe,
    FeatureFlagDirective,
    TranslateCutPipe,
    NouisliderModule
  ],
  providers: [
    DecimalPipe,
    CurrencyPipe
  ]
})
export class SharedModule { }
